import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box } from 'src/components/Box';
import { CircularProgress } from 'src/components/CircularProgress';
import { Container } from 'src/components/Container';
import { Meta } from 'src/components/Meta';
import { Typography } from 'src/components/Typography';
import { fetchWorkoutPlansWithLeaderboards } from 'src/models/leaderboard/leaderboard';
import { AppFrameConfig } from 'src/shared/AppFrame/AppFrameConfig';

import { LeaderboardCard } from './components/LeaderboardCard';

export const LeaderboardCalendarsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('translation', {
    keyPrefix: 'leaderboard.public',
  });

  const { data: plans, isLoading } = useQuery({
    queryKey: ['leaderboardWorkoutPlans'],
    queryFn: fetchWorkoutPlansWithLeaderboards,
  });

  return (
    <>
      <Meta title={t('title')} />
      <AppFrameConfig
        id="leaderboard-calendars"
        containerMaxWidth="xl"
        title={t('title')}
        backButtonLinkTo="/leaderboards/public"
        backButtonTitle={t('title')}
      />
      <Container>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
            {(plans || []).map((plan: any) => (
              <LeaderboardCard
                key={plan.id}
                name={plan.name}
                image={plan.image_url || plan.large_plan_image}
                onClick={() =>
                  navigate(`/leaderboards/public/calendars/${plan.id}`)
                }
              />
            ))}
            {(!plans || plans.length === 0) && (
              <Typography variant="body2" sx={{ pl: 2 }}>
                {t('noResults')}
              </Typography>
            )}
          </Box>
        )}
      </Container>
    </>
  );
};
